// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"9a6818c1","455":"2592b6ac","977":"f339442d"}[chunkId] + ".chunk.js";
};